// Conteúdo do popup de contexto exibido no cadastro conforme o tema do anúncio (?tema=), sem UTM/tracking/backend.
export const registerThemePopups = {
  "black-friday": {
    titulo: "CRIE SEU ENCARTE DE BLACK FRIDAY 🔥",
    subtitulo:
      "Escolha entre novos temas, coloque os produtos da sua loja e monte seu encarte promocional em poucos minutos.",
    selos: [
      "/images/selos/black-friday.jpg",
      "/images/selos/black-friday-2.jpg",
      "/images/selos/black-friday-3.jpg",
    ],
    cta: "CRIAR MEU ENCARTE",
  },
  dodia: {
    titulo: "MERCADORIA NO PREÇO PRECISANDO DIVULGAR AINDA HOJE?",
    subtitulo:
      "Com nosso sistema você consegue criar encartes sem complicação: em menos de um minuto sua oferta do dia está na mão do seu cliente.",
    selos: [
      "/images/selos/do-dia-1.jpg",
      "/images/selos/do-dia-2.jpg",
      "/images/selos/do-dia-4.jpg",
    ],
    cta: "CRIAR MEU ENCARTE",
  },
  "ano-novo": {
    titulo: "CRIE SEU ENCARTE DE ANO NOVO",
    subtitulo: "Comece o ano divulgando suas ofertas com destaque.",
    selos: ["", ""],
    cta: "CRIAR MEU ENCARTE",
  },
  ofertas: {
    titulo: "COLOQUE SUAS OFERTAS EM DESTAQUE",
    subtitulo: "Crie um encarte profissional para divulgar sua loja.",
    selos: ["", ""],
    cta: "CRIAR MEU ENCARTE",
  },
  rapidez: {
    titulo: "SEU ENCARTE PRONTO EM POUCOS MINUTOS",
    subtitulo: "Crie suas ofertas de forma rápida, simples e profissional.",
    selos: ["", ""],
    cta: "CRIAR MEU ENCARTE",
  },
};

// Sem tema reconhecido (acesso direto ou tema desconhecido) -> nenhum popup é exibido.
export function getRegisterThemePopup(tema) {
  return registerThemePopups[tema] || null;
}
